import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,[_c(VCol,{staticClass:"text-center"},[(_vm.step > 1)?_c(VBtn,{staticClass:"mr-3",on:{"click":_vm.prevClickWrap}},[_vm._v("Back")]):_vm._e(),(_vm.showNext)?_c(VBtn,{attrs:{"color":"primary","disabled":_vm.disabled || _vm.internalNextDisable},on:{"click":_vm.nextClickWrap}},[_vm._v(_vm._s(_vm.nextButtonText === undefined ? 'Continue' : _vm.nextButtonText))]):_vm._e(),_vm._t("right")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }